import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SessionChecker from '../../components/Change/SessionChecker';
import MyAccountAction from '../actions/MyAccountAction';

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    checkSession: MyAccountAction.checkSessionActive
  }, dispatch);

const SessionCheckerContainer = connect(mapStateToProps, mapDispatchToProps)(SessionChecker);

export default SessionCheckerContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/SessionCheckerContainer.js
 **/